var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C5.89543 0 5 0.895431 5 2V16C5 17.1046 5.89543 18 7 18H21C22.1046 18 23 17.1046 23 16V2C23 0.89543 22.1046 0 21 0H7ZM21.2692 14.2692C21.2692 15.3738 20.3738 16.2692 19.2692 16.2692H8.73077C7.6262 16.2692 6.73077 15.3738 6.73077 14.2692V3.73077C6.73077 2.6262 7.6262 1.73077 8.73077 1.73077H19.2692C20.3738 1.73077 21.2692 2.6262 21.2692 3.73077V14.2692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73077 20.2692C3.6262 20.2692 2.73077 19.3738 2.73077 18.2692V12.6538V5.73077V4.86538C2.73077 4.38745 2.34332 4 1.86538 4V4C1.38745 4 1 4.38745 1 4.86538V20C1 21.1046 1.89543 22 3 22H18.1346C18.6126 22 19 21.6126 19 21.1346V21.1346C19 20.6567 18.6126 20.2692 18.1346 20.2692H17.2692H4.73077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1744 12.73L16.0689 7.83555V11.357H17.73V5H11.373V6.66111H14.8944L10 11.5555L11.1744 12.73Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/Open.3e175401e497e3e30805da666dd73257.svg";
export { ForwardRef as ReactComponent };